import $ from 'jquery';
import { Shows, } from '../model/index';
import { getShowsJqXHR,} from '../api';

/**
* 展示会コードが来場予定に該当するかチェックする。OK:展示名を返す、NG:空で返す
* code:展示会コード brFlg:改行フラグ
*/
export async function confexhi(code : string, brFlg : number) {
  let exhibitionName: string = "";
  const result = await getShowsJqXHR();
  for (let value of result as Shows[]) {
    let regist_start = new Date(value.regist_start);
    let regist_end = new Date(value.regist_end);
    let today = new Date();
    // コード一致 & status:yes & 期間内の場合
    if ((code == value.tenji_key)
      && (value.registable_status == 'yes')
      && (regist_start <= today)
      && (regist_end >= today)) {
        exhibitionName = value.tenji_name + (brFlg === 1?'<br>':'') + value.date_name;
        break;
    }
  }
  return exhibitionName;
}

